import { render, staticRenderFns } from "./ProCard.vue?vue&type=template&id=c8afb7fa&scoped=true"
import script from "./ProCard.vue?vue&type=script&lang=js"
export * from "./ProCard.vue?vue&type=script&lang=js"
import style0 from "./ProCard.vue?vue&type=style&index=0&id=c8afb7fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8afb7fa",
  null
  
)

export default component.exports